var map = {
	"./a-guide-on-how-to-navigate-u-of-t-research-and-employment-landscape.md": 4078,
	"./a-guide-to-navigating-long-distance-friendships.md": 9625,
	"./a-guide-to-teams-to-watch-and-events-to-attend-in-toronto.md": 6651,
	"./an-overview-of-some-of-u-of-t-st-georges-libraries.md": 5451,
	"./cheap-tasty-and-quality-food-around-campus.md": 1655,
	"./cultural-hotspots-in-toronto.md": 8460,
	"./getting-involved-with-the-varsity.md": 8465,
	"./housing-tips-for-finding-a-place-in-toronto.md": 1085,
	"./how-physical-activity-can-improve-your-academic-performance.md": 9576,
	"./how-to-manage-your-courseload.md": 5533,
	"./i-make-time-to-go-outside-you-should-too.md": 8231,
	"./important-news-stories.md": 9741,
	"./important-people-at-u-of-t.md": 3310,
	"./mental-physical-and-academic-resources-for-every-u-of-t-student.md": 9477,
	"./networking-in-your-undergrad.md": 6510,
	"./places-of-worship-and-religious-and-spiritual-associations-at-u-of-t.md": 2138,
	"./sexual-health-care-at-u-of-t.md": 7631,
	"./socializing-from-scratch.md": 3111,
	"./the-best-toronto-date-spots-for-university-students.md": 3132,
	"./ways-to-get-involved-creatively-at-u-of-t.md": 1290
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5553;